define('modules/static-data-fetcher/js/usecase-service/techdata-options-ucs',['require','sdk!ivCore'],function(require) {
    "use strict";
    
    var iv = require('sdk!ivCore');
    
    var SearchOptionsService = iv.Usecaseservice.extend({
        updateSuccessResponse : function(resp) {
    		if (resp.data.categories) {
                resp.data.categories = this.model.parseTechData(resp.data.categories);
                resp.data.withOnlyProducts = this.model.parseTechDataWithOnlyProducts(resp.data.categories);
    			this.model.set({
    				techData: resp.data.categories,
                    techDataWithOnlyProducts : resp.data.withOnlyProducts
    			});
    		}
    		
            this.trigger('fetch.techdata.options.success', 'techData');
        },
        updateErrorResponse: function (resp) {
            this.trigger('fetch.techdata.options.failure', resp);
        }
    });
    return SearchOptionsService;
});
